import { render, staticRenderFns } from "./VuetifyFooter.vue?vue&type=template&id=1db0e09c&"
import script from "./VuetifyFooter.vue?vue&type=script&lang=js&"
export * from "./VuetifyFooter.vue?vue&type=script&lang=js&"
import style0 from "./VuetifyFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports